<script setup>
import Icon from '@components/Icon.vue'

defineProps({
  maxWidth: {
    type: [String, Number],
    default: 800,
  },
  title: {
    type: String,
    default: '',
  },
  dismissable: {
    type: Boolean,
    default: true,
  },
  modelValue: {
    required: true,
  }
})

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <div class="modal" :class="{'modal--active': !!modelValue}">
    <div class="modal__content" :style="`max-width: ${maxWidth}px`">
      <div v-if="title || dismissable" class="modal__heading">
        <div class="modal__title">{{ title }}</div>
        <a v-if="dismissable" href="#" @click.prevent="emit('update:modelValue', false)">
          <Icon type="close" />
        </a>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.35);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;

  &.modal--active {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }

  .modal__content {
    width: calc(100% - 40px);
    max-height: 95%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 16px;
    background: white;
    overflow-y: auto;
    border-radius: 8px;

    @media screen and (min-width: 768px) {
      border-radius: 16px;
      padding: 32px;
    }

    .modal__heading {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 16px 0;

      .modal__title {
        font-family: Outfit, 'Outfit Fallback', Arial, serif;
        font-weight: 700;
        color: var(--Neutral-1000, #3C3833);
        font-size: 20px;
        line-height: 28px;
        margin: 0;

        @media screen and (min-width: 768px) {
          font-size: 24px;
          line-height: 32px;
        }
      }
    }
  }
}
</style>
